import React from "react";
import Photos from "../../../components/forms/productForms/categoryAndPhotos/photos";

export default function FourPageForm() {
  return (
      <Photos />
  );
}
